(()=>{

  const Tab = document.querySelector('.store-information__body');

  document.querySelectorAll('.store-information__tabs-button').forEach((ele)=>{
    ele.addEventListener('click',(e)=>{
      const activebutton = e.target;
      const target = e.target.getAttribute('aria-controls');

      Tab.querySelector('.active').classList.remove('active');

      Tab.querySelectorAll('.store-information__panel').forEach((e)=>{
        e.setAttribute('aria-hidden', 'true')
      })
      Tab.querySelectorAll('.store-information__tabs-button').forEach((e)=>{
        e.setAttribute('aria-expanded', 'false')
      })

      activebutton.classList.add('active');
      activebutton.setAttribute('aria-expanded', 'true');
      document.querySelector(`#${target}`).setAttribute('aria-hidden', 'false');

    })

  });

})();
